export default __webpack_public_path__ + "static/media/livingroom6.890b1fc5.webp";